import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Search, ArrowDropDown, ArrowDropUp } from '@mui/icons-material/';

const SelectFilter = ({
  array,
  className,
  required,
  listTitle,
  addNewElement,
  propertyShown,
  deleteSelection,
  selectValue,
  setSelectValue,
  placeholderInput,
  placeholderFilter,
  loading,
}) => {
  const [displayList, setDisplayList] = useState(false);
  const [list, setList] = useState(array);
  const [filterValue, setFilterValue] = useState();

  const handleFilterList = (value) => {
    const filteredList = array.filter((item) => item[propertyShown].toLowerCase().includes(value.toLowerCase()));
    setList(filteredList);
  };

  useEffect(() => {
    setList(array);
  }, [array]);

  return (
    <div className={`${className} select-filter-container`}>
      <div className="select-option-input-container">
        {displayList ? <ArrowDropUp /> : <ArrowDropDown />}
        <input
          type="text"
          placeholder={displayList ? 'Cerrar ventana' : placeholderInput}
          className="select-option-input"
          onClick={() => setDisplayList(!displayList)}
          value={selectValue?.selectedOption || ''}
          required={required}
        />
      </div>
      {displayList && (
        <div className="select-filter-list">
          <div className="filter-input-container">
            <Search />
            <input
              type="text"
              className="filter-input"
              placeholder={placeholderFilter}
              onFocus={() => setDisplayList(true)}
              value={filterValue}
              onChange={(e) => {
                setFilterValue(e.target.value);
                handleFilterList(e.target.value);
              }}
            />
          </div>
          {deleteSelection && (
          <div
            className="option"
            role="none"
            onClick={() => {
              setDisplayList(false);
              setSelectValue({ selectedOption: '' });
            }}
          >
            <p>Borrar seleccion</p>
          </div>
          )}
          {addNewElement && (
          <div
            className="option"
            role="none"
            onClick={() => {
              setSelectValue({ selectedOption: addNewElement });
              setDisplayList(false);
            }}
          >
            <p>{addNewElement}</p>
          </div>
          )}
          {(list?.length > 0 || loading) && (<p className="message-divider">{listTitle}</p>)}
          <div className="list-wrapper">
            {loading && (
            <div className="list-wrapper">
              <div
                className="option"
              >
                <p>Cargando ...</p>
              </div>
            </div>
            )}
            {(list?.length > 0 && !loading) && list.map((item) => (
              <div
                className="option"
                role="none"
                onClick={() => {
                  setSelectValue({ ...item, selectedOption: item[propertyShown] });
                  setDisplayList(false);
                }}
              >
                <p>{item[propertyShown]}</p>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

SelectFilter.propTypes = {
  className: PropTypes.string,
  array: PropTypes.arrayOf(),
  required: PropTypes.bool,
  listTitle: PropTypes.string,
  addNewElement: PropTypes.string,
  propertyShown: PropTypes.string,
  selectValue: PropTypes.objectOf(),
  setSelectValue: PropTypes.func,
  placeholderFilter: PropTypes.string,
  placeholderInput: PropTypes.string,
  loading: PropTypes.bool,
  deleteSelection: PropTypes.bool,
};

SelectFilter.defaultProps = {
  className: '',
  array: [],
  required: false,
  listTitle: '',
  addNewElement: '',
  propertyShown: '',
  selectValue: {},
  setSelectValue: () => {},
  placeholderFilter: 'Buscar',
  placeholderInput: 'Selecciona una opcion',
  loading: false,
  deleteSelection: false,
};

const mapStateToProps = (state) => (
  {
    calculationsData: state.calculationsData,
  });

const mapDispatchToProps = (dispatch) => ({
  setCalculationsData: (values) => dispatch({
    type: 'SET_CALCULATIONS_DATA',
    payload: values,
  }),
});

export default connect(mapStateToProps, mapDispatchToProps)(SelectFilter);
